<script>
  import { _ } from 'svelte-i18n';

  import Step from "./Step.svelte";
  import StepHeader from "./StepHeader.svelte";
  import ExerciseVerification from "./ExerciseVerification.svelte";
  import { preprocess, check, save } from "./ExerciseVerification.svelte";

  export let course;
  export let mod;
  export let step;
  export let justified;
  export let prevFn;
  export let nextFn;

  let badSyntax = false;
  let passedExercise;

  let task_descriptions = [], assignments = [];

  function checkAssignments(ev) {
    passedExercise = check(assignments);
    save(mod, step, assignments);
    assignments = assignments; // triggers update
  }

  try {
    [task_descriptions, assignments] = preprocess(step.content, '');
  } catch {
    badSyntax = true;
  }
</script>

<Step {justified} {prevFn} {nextFn}>
  <StepHeader {course} {mod} />

  <div class:hidden="{!badSyntax}">
    <ExerciseVerification {course} {mod} {step} />
  </div>

  <div class:hidden="{badSyntax}" class="w-11/12 mt-4 mb-4 bg-base-200">

    {#if passedExercise === true}
      <div class="my-8">
        <img class="mx-auto" src="/assets/test_passed.svg" />
        <p class="text-4xl pt-4 font-bold text-center uppercase"> {$_('course.good_job')} </p>
      </div>

    {:else}
      <div class="card w-3/4 my-10 mx-auto pt-4 relative">
        <div class="card-body pt-2 px-16 z-20">
          <div class="prose max-w-none">
            <h2 class="text-4xl font-bold text-center mb-2"> {step.title} </h2>

            <h5 class="font-bold text-center">
              {#each task_descriptions as desc}
                {@html desc.innerHTML}
              {/each}
            </h5>
          </div>

          <ul class="mb-20">
            {#each assignments as a, i}
              <li bind:this="{a.answer}" class="ml-10 mt-6 relative">
                <span class="inline-block align-top w-2 text-center mr-2"
                  class:text-primary={a.correctness === true}
                  class:text-error={a.correctness === false}>
                  {#if a.correctness == true}
                    ✓
                  {:else if a.correctness == false}
                    ✗
                  {:else} 
                    •
                  {/if}
                </span>

                <span class="inline-block w-3/4"> {@html a.innerHTML} </span>

                <div class="absolute right-10 top-1/2 -translate-y-1/2">
                  <input type="radio" name="r{i}" class="radio radio-primary" bind:group={a.givenAnswer} value="T" data-label="{$_('course.true')}" />
                  <input type="radio" name="r{i}" class="radio radio-primary" bind:group={a.givenAnswer} value="F" data-label="{$_('course.false')}" />
                </div>
              </li>
            {/each}
          </ul>

          <button class="btn btn-primary" on:click="{checkAssignments}">
            {passedExercise === undefined ? $_('course.check') : $_('course.retry')}
          </button>
        </div>
      </div>
    {/if}

  </div>
</Step>

<style>
  input[type=radio] {
    background: transparent;
    border: none;
    display: inline;
    padding: .2em .5em;
    font-weight: bold;
  }

  input[type=radio]:checked {
    color: hsl(var(--p));
    box-shadow: 0 0 0 4px hsl(var(--p)) inset, 0 0 0 4px hsl(var(--p)) inset;
    animation: radiocustom var(--animation-input, 0.2s) ease-in-out;
  }

  input[type=radio]:before {
    content: attr(data-label);
  }

@keyframes radiocustom {
  0% {
    box-shadow: 0 0 0 12px hsl(var(--p)) inset, 0 0 0 12px hsl(var(--p)) inset;
  }
  50% {
    box-shadow: 0 0 0 3px hsl(var(--p)) inset, 0 0 0 3px hsl(var(--p)) inset;
  }
  100% {
    box-shadow: 0 0 0 4px hsl(var(--p)) inset, 0 0 0 4px hsl(var(--p)) inset;
  }
}
</style>